module.exports = __webpack_public_path__ + "img/encriptacao_ponto_a_ponto.a9405882.png";